import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { SideMenuFilterItem } from '@vlabs/monokit/shared/ui/side-menu-filter-item';

// eslint-disable-next-line import-x/no-namespace
import * as Popovers from './popovers';

const withLeftPopover = withPopover({ placement: 'left' });
const withSideMenuItemLeftPopover = withLeftPopover(SideMenuFilterItem);

export const CreationDateFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.CreationDateFilterPopover);
export const UpdateDateFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.UpdateDateFilterPopover);
export const NameFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.NameFilterPopover);
